<script setup lang="ts">
import CaretRightIcon from '@/assets/images/svg/caret-right.svg?component';
import { TAppVersionReport, TSingleScanReport } from '@/_core/entities/report/models/types';
import { computed } from 'vue';

const props = defineProps<{
  reportData: TAppVersionReport | TSingleScanReport;
  integrationId?: string;
  branchName?: string;
}>();

const isIntegrationReport = computed(() => 'integrationName' in props.reportData);

const topLevelBreadcrumb = computed(() => {
  if (isIntegrationReport.value) {
    return (props.reportData as TAppVersionReport).integrationName || props.reportData.fileName;
  }

  return props.reportData.fileName;
});

const versionsLink = computed(() => {
  if (!props.integrationId || !props.branchName) return null;

  // should reflect the respective path in router.js
  return `/integration/${props.integrationId}/branch/${props.branchName}`;
});
</script>

<template>
  <div class="tw:pl-2.5 tw:flex tw:items-center tw:gap-2.5 tw:justify-start">
    <div class="tw:flex tw:items-center tw:gap-1.5 tw:text-ghost">
      <router-link
        v-if="versionsLink"
        :to="versionsLink"
        class="tw:typography-small tw:text-ghost! tw:lg:hover:text-main-blue! tw:transition-colors tw:no-underline!"
        >{{ topLevelBreadcrumb }}</router-link
      >
      <div v-else class="tw:typography-small">{{ topLevelBreadcrumb }}</div>
      <div class="tw:w-1.75 tw:grow-0">
        <CaretRightIcon />
      </div>
    </div>
    <div class="tw:flex tw:gap-1 tw:grow tw:text-main-blue tw:typography-small">
      <div>Version</div>
      <div>{{ reportData.version }}</div>
    </div>
  </div>
</template>
